module.exports = __webpack_public_path__ + "img/repair-6.dd2f83e6.jpg";